export default __webpack_public_path__ + "static/media/Community-Living-Insurance-Policy-April-2023.df894faf.pdf";